import { render, staticRenderFns } from "./MyRequestDocPop.vue?vue&type=template&id=c15cb0c4"
import script from "./MyRequestDocPop.vue?vue&type=script&lang=js"
export * from "./MyRequestDocPop.vue?vue&type=script&lang=js"
import style0 from "./MyRequestDocPop.vue?vue&type=style&index=0&id=c15cb0c4&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c15cb0c4')) {
      api.createRecord('c15cb0c4', component.options)
    } else {
      api.reload('c15cb0c4', component.options)
    }
    module.hot.accept("./MyRequestDocPop.vue?vue&type=template&id=c15cb0c4", function () {
      api.rerender('c15cb0c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/MyRequestDocPop.vue"
export default component.exports